import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";

export default function EthosBanner() {
  return (
    <section className="pb-4 pt-4" data-testid="ethos-banner">
      <div className="container mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-[2rem] bg-[#0A2540] px-8 py-10 md:px-14 md:py-12"
        >
          <div className="blob absolute -top-20 -right-16 w-72 h-72 rounded-full bg-[#FF7A1A]/25" />
          <div className="blob absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-[#0EA5E9]/25" />
          <div className="relative flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
            <span className="grid place-items-center w-14 h-14 rounded-2xl bg-[#FF7A1A] text-white shrink-0">
              <Heart size={26} />
            </span>
            <div className="flex-1">
              <p className="text-sm text-[#38BDF8] tracking-[0.25em] uppercase font-bold">Our ethos</p>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl lg:text-4xl font-black tracking-tight text-white leading-tight">
                Bonding is at our heart — the whole family, in the water together.
              </h2>
              <p className="mt-2 text-[#CBD5E1]">
                In our Urchins &amp; Small Fry classes we welcome two adults into the pool — mum, dad,
                grandparents and all. We encourage everyone who'll be in the water with your little
                one to dive in, because these moments matter and adults learn too. Knowing how to
                keep your child safe and confident in the water is a gift that lasts a lifetime.
              </p>
            </div>
            <Link
              to="/classes/baby-swimming"
              className="inline-flex items-center gap-2 self-start lg:self-auto bg-white/10 text-white font-bold px-7 py-3.5 rounded-full border border-white/20 hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
              data-testid="ethos-banner-cta"
            >
              Discover baby swimming <ArrowRight size={18} />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
